if (!customElements.get('offer-flyout')) {
  class OfferFlyout extends HTMLElement {

    static observedAttributes = ["open"];

    constructor() {
      super();
      this.flyout = this.querySelector('[data-offer-flyout]');
      this.flyoutClose = this.querySelector('[data-offer-close]');
      this.overlay = document.querySelector('[data-overlay]');
      this.overlay.addEventListener('click', this.handleClickClose.bind(this));
      this.flyoutClose.addEventListener('click', this.handleClickClose.bind(this));
      this.init();
    }

    hideOffers() {
      this.setAttribute('open', false);
    }

    init() {
      const component = this;
      document.addEventListener('keydown', (event) => {
        if (event.code === 'Escape') {
          component.hideOffers();
        }
      });
    }

    handleClickClose() {
      this.hideOffers();
    }

    attributeChangedCallback(name, prev, next) {
      if (name === 'open') {
        if (next === 'true') {
          this.flyout.classList.add('active');
          this.overlay.classList.add('active');
        } else {
          this.flyout.classList.remove('active');
          this.overlay.classList.remove('active');
        }
      }
    }
  }
  customElements.define('offer-flyout', OfferFlyout);
}

if (!customElements.get('offer-button')) {
  class OfferButton extends HTMLElement {

    static observedAttributes = ["open"];

    constructor() {
      super();
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.handleClick.bind(this));
      this.modal = this.querySelector('[data-offer-popover]');
      this.modalClose = this.querySelector('[data-offer-popover-close]');
      this.modalClose.addEventListener('click', this.setHidden.bind(this));
      this.initPopoverTimeout();
    }

    setHidden() {
      sessionStorage.setItem('offerPopover', 'hidden');
      this.modal.classList.remove('active');
    }

    initPopoverTimeout() {
      const popoverStorage = sessionStorage.getItem('offerPopover');
      if (popoverStorage == 'hidden') return;
      const component = this;
      component.modal.classList.add('active');
      setTimeout(() => {
        component.setHidden();
      }, 6000);
    }

    handleClick() {
      document.querySelector('offer-flyout').setAttribute('open', true);
      Cart.setAttributes({ "_viewed_offers": true });
      this.classList.add('active')
    }
  }
  customElements.define('offer-button', OfferButton);
}

if (!customElements.get('offer-details')) {
  class OfferDetailsButton extends HTMLElement {

    static observedAttributes = ["open"];

    constructor() {
      super();
      this.details = this.querySelector('[data-offer-details]');
      this.addEventListener('click', this.openDetails.bind(this));
    }

    openDetails() {
      document.querySelector('[data-dialog-entry]').innerHTML = this.details.innerHTML;
      showDialog();
    }
  }
  customElements.define('offer-details', OfferDetailsButton);
}